import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { useMountEffect } from "primereact/hooks";
import { Field } from "react-final-form";
import { sessionRequest, resetState } from "../../../store/slices/authSlice";
import Link from "../../common/link";
import { TextInput, Checkbox } from "../../common/fields";
import Form from "../../common/form";
import * as Validations from "../../common/form/validator";
import { RouteConstants } from "../../../constants";
import PreLoginContainer from "../../common/preLoginContainer";
import { useLocation, useSearchParams } from "react-router-dom";
import * as GlobalHelper from "../../../helpers/GlobalHelper";

const LoginLocal = ({
  sessionRequest,
  requesting,
  action,
  error,
  resetState,
  global,
}) => {
  const intl = useIntl();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isRootDomain = GlobalHelper.CheckIfRootDomain(
    window.location.hostname.split(".")[0]
  );

  useMountEffect(() => {
    resetState();
  });

  const userName =
    (searchParams.get("params") &&
      atob(decodeURIComponent(searchParams.get("params")))) ||
    null;

  return (
    <PreLoginContainer showLoginMessage={true}>
      <div className="title text-center">
        {intl.formatMessage({
          id: "sign_in_password",
        })}
      </div>
      <Form
        initialValues={{
          username:
            userName ||
            location?.state?.username ||
            Cookies.get("username") ||
            "",
        }}
        fullWidthButtons
        requesting={action === "sign-in" && requesting}
        submitBtn={{
          label: intl.formatMessage({
            id: "sign_in",
          }),
          icon: "pi-arrow-right",
          onClick: (values) => {
            sessionRequest(values);
            if (values.rememberMe) {
              Cookies.set("username", values.username, {
                expires: 30,
                secure: true,
                sameSite: "Strict",
              });
            }
          },
        }}
      >
        <div className="flex flex-column gap-2 mt-4">
          <Field
            name="username"
            component={TextInput}
            type="text"
            icon="pi-user"
            placeholder={intl.formatMessage({
              id: "username",
            })}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
          <Field
            name="password"
            component={TextInput}
            type="password"
            placeholder={intl.formatMessage({
              id: "password",
            })}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
          <Field
            name="rememberMe"
            component={Checkbox}
            type="checkbox"
            label={intl.formatMessage({ id: "remember_me" })}
          />
          {(error && !requesting && action === "sign-in" && (
            <div className="error-message">
              {intl.formatMessage({
                id: (error?.response || "unknown_error").toLowerCase(),
              })}
            </div>
          )) ||
            null}
          <div className="flex justify-content-between align-items-center">
            <Link to={RouteConstants.APP_ROUTE_FORGOT_PASSWORD}>
              {intl.formatMessage({
                id: "forgot_password_link",
              })}
            </Link>
            {(global?.enterprise && (
              <Link
                to={RouteConstants.APP_ROUTE_OTP}
                style={{ paddingRight: "0" }}
                state={{
                  username:
                    userName ||
                    location?.state?.username ||
                    Cookies.get("username"),
                }}
              >
                {intl.formatMessage({
                  id: "otp_link",
                })}
              </Link>
            )) ||
              null}
          </div>
        </div>
      </Form>
      {(!isRootDomain && (
        <div className="text-center mt-1">
          <Link to={RouteConstants.APP_ROUTE_LOGIN}>
            {intl.formatMessage({ id: "back_to_login" })}
          </Link>
        </div>
      )) ||
        null}
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  requesting: state.auth.requesting,
  error: state.auth.error,
  action: state.auth.action,
  global: state.global,
});

const mapDispatchToProps = (dispatch) => ({
  sessionRequest: (data) => dispatch(sessionRequest(data)),
  resetState: () => dispatch(resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginLocal);
